import { render, staticRenderFns } from "./ProcurementPurchaseReceipt.vue?vue&type=template&id=1e7592dc"
import script from "./ProcurementPurchaseReceipt.vue?vue&type=script&lang=js"
export * from "./ProcurementPurchaseReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports